import { __ } from "@wordpress/i18n";
import * as Yup from "yup";
import {
  QUOTE_EQUITY_OPTIONS,
  QUOTE_EQUITY_PROPERTY_VALUE_MIN,
  QUOTE_EQUITY_PROPERTY_VALUE_MAX, QUOTE_EQUITY_LOAN_TERMS_MIN, QUOTE_EQUITY_LOAN_TERMS_MAX,
  QUOTE_EQUITY_NET_INCOME_MIN, QUOTE_EQUITY_NET_INCOME_MAX,
} from "./FormConfig";
import { validationsLocale } from "./ValidationsLocale";

Yup.setLocale(validationsLocale);

const MESSAGES = {
  required: __("Este campo é de preenchimento obrigatório.", "df-simulators"),
  oneOf: __("O valor selecionado é inválido.", "df-simulators"),
};

export const validations: Record<string, Yup.ObjectSchema<any>> = {
  quote_equity: Yup.object().shape({
    propertyValue: Yup.number()
      .typeError(MESSAGES.required)
      .min(QUOTE_EQUITY_PROPERTY_VALUE_MIN)
      .max(QUOTE_EQUITY_PROPERTY_VALUE_MAX)
      .required(MESSAGES.required),
    region: Yup.string()
      .oneOf(
        QUOTE_EQUITY_OPTIONS.region.map((option) => option.value),
        MESSAGES.oneOf,
      )
      .required(MESSAGES.required),
    loanTermInYears: Yup.number()
      .typeError(MESSAGES.required)
      .min(QUOTE_EQUITY_LOAN_TERMS_MIN)
      .max(QUOTE_EQUITY_LOAN_TERMS_MAX)
      .required(MESSAGES.required),
    monthlyNetIncome: Yup.number()
      .typeError(MESSAGES.required)
      .moreThan(QUOTE_EQUITY_NET_INCOME_MIN,
        __("O rendimento mensal líquido deve ser maior ou igual a zero", "df-simulators"))
      .max(QUOTE_EQUITY_NET_INCOME_MAX)
      .required(MESSAGES.required),
    condition: Yup.string()
      .oneOf(
        QUOTE_EQUITY_OPTIONS.condition.map((option) => option.value),
        MESSAGES.oneOf,
      )
      .required(MESSAGES.required),
    rateType: Yup.string()
      .oneOf(QUOTE_EQUITY_OPTIONS.rateType.map((option) => option.value), MESSAGES.oneOf)
      .required(MESSAGES.required),
    country: Yup.string().oneOf(["ES"]).required(),
  }),
};
